import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Sidebar from "../../components/Sidebar/Sidebar";


import appRoutes from "../../routes/app.jsx";

import Header from '../../components/Header/Header';

class App extends Component {

  constructor(props){
    super(props);
    this.state={
      isLoggedin:false,
    }
}
  componentDidMount(){
    let g= localStorage.getItem("NAME") ||"not found";
    
    let query=this.props.location.query || {log:false};
    console.log("App name ", g);
    if(g !=="not found"){
      this.setState({isLoggedin:true});
    }
    else if(query.log){
      console.log("User has logged in");
      this.setState({isLoggedin:true});
    }
    else{
      let hist= this.props.history;
      hist.push('/login');
    }
  }
  componentDidUpdate(e) {
   
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  render() {
    return (
      <div className="wrapper">
        <Sidebar {...this.props} />
        <div id="main-panel" className="main-panel">
          <Header {...this.props}>
            
          </Header>
          <Switch>
              {appRoutes.map((prop, key) => {
                if (prop.redirect)
                  return <Redirect from={prop.path} to={prop.to} key={key} />;
                return (
                  <Route path={prop.path} component={prop.component} key={key} />
                );
              })}
            </Switch>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx